import type { Locale } from "@/config/experience";
import type { Industry } from "@/domain/catalog";

export interface LocalServiceCopy {
  navLabel: string;
  eyebrow: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  intro: string;
  categoryCta: string;
  contactCta: string;
  highlightsTitle: string;
  highlights: Array<{ title: string; body: string }>;
  selectionTitle: string;
  selectionIntro: string;
  selection: Array<{ title: string; body: string }>;
  productsTitle: string;
  productsIntro: string;
  processTitle: string;
  process: Array<{ title: string; body: string }>;
  faqTitle: string;
  faqs: Array<{ question: string; answer: string }>;
  finalTitle: string;
  finalBody: string;
}

export interface LocalServicePageDefinition {
  slug: string;
  industry: Industry;
  categorySlug: string;
  serviceType: string;
  vi: LocalServiceCopy;
  en: LocalServiceCopy;
}

export const localServicePages: LocalServicePageDefinition[] = [
  {
    "slug": "khoa-thong-minh-da-nang",
    "industry": "smart-lock",
    "categorySlug": "khoa-thong-minh",
    "serviceType": "Tư vấn và lắp đặt khóa thông minh",
    "vi": {
      "navLabel": "Khóa thông minh Đà Nẵng",
      "eyebrow": "GIẢI PHÁP TẠI ĐÀ NẴNG",
      "title": "Khóa thông minh Đà Nẵng – tư vấn, bán lẻ & lắp đặt",
      "metaTitle": "Khóa thông minh Đà Nẵng | Tư vấn & lắp đặt | T Smart",
      "metaDescription": "Tư vấn, bán lẻ và lắp đặt khóa thông minh chính hãng tại Đà Nẵng. Chọn Face ID, vân tay, tĩnh mạch theo loại cửa, model và thương hiệu.",
      "intro": "T Smart chuyên tư vấn, bán lẻ và lắp đặt khóa thông minh chính hãng tại Đà Nẵng. Mỗi model được đối chiếu theo loại cửa, độ dày, đố cửa, thân khóa và nhu cầu sử dụng trước khi đề xuất.",
      "categoryCta": "Xem toàn bộ khóa thông minh",
      "contactCta": "Tư vấn khóa qua Zalo",
      "highlightsTitle": "Chọn khóa theo đúng điều kiện thực tế",
      "highlights": [
        {
          "title": "Theo loại cửa",
          "body": "Đối chiếu cửa gỗ, cửa nhôm, cửa kính, cửa cổng cùng độ dày và chiều rộng đố cửa."
        },
        {
          "title": "Theo công nghệ",
          "body": "So sánh Face ID, vân tay, mã PIN, thẻ từ và tĩnh mạch theo người sử dụng."
        },
        {
          "title": "Theo phương án lắp",
          "body": "Kiểm tra thân khóa, hướng mở, tay nắm và các chi tiết ảnh hưởng thẩm mỹ sau thi công."
        }
      ],
      "selectionTitle": "3 bước chọn khóa phù hợp",
      "selectionIntro": "Không nên chọn khóa chỉ theo hình thức. Kết cấu cửa và thông số lắp đặt cần được xác minh trước.",
      "selection": [
        {
          "title": "1. Xác định loại cửa",
          "body": "Ghi nhận vật liệu, độ dày cánh, chiều rộng đố và hướng mở."
        },
        {
          "title": "2. Chọn phương thức mở",
          "body": "Ưu tiên công nghệ phù hợp gia đình, trẻ nhỏ, người lớn tuổi và nhu cầu từ xa."
        },
        {
          "title": "3. Đối chiếu model",
          "body": "So sánh thông số, giá, biến thể và khả năng lắp thực tế trước khi chốt."
        }
      ],
      "productsTitle": "Một số model khóa đang có trên T Smart",
      "productsIntro": "Danh sách lấy trực tiếp từ danh mục khóa thông minh để bạn mở chi tiết và so sánh.",
      "processTitle": "Quy trình tư vấn khóa tại Đà Nẵng",
      "process": [
        {
          "title": "Tiếp nhận nhu cầu",
          "body": "Gửi hình cửa, kích thước cơ bản và tính năng ưu tiên."
        },
        {
          "title": "Đối chiếu kỹ thuật",
          "body": "Sàng lọc model theo kết cấu cửa và thông số lắp đặt."
        },
        {
          "title": "Khảo sát khi cần",
          "body": "Cửa nhôm, kính, cổng hoặc kết cấu đặc thù nên xác minh hiện trạng trước."
        },
        {
          "title": "Lắp đặt & hướng dẫn",
          "body": "Căn chỉnh khóa, kiểm tra đóng mở và hướng dẫn cài đặt người dùng."
        }
      ],
      "faqTitle": "Câu hỏi thường gặp về khóa thông minh tại Đà Nẵng",
      "faqs": [
        {
          "question": "Cửa nhôm có lắp khóa Face ID được không?",
          "answer": "Có nhiều model phù hợp, nhưng cần kiểm tra chiều rộng đố, độ dày cánh và khoảng trống cho thân khóa."
        },
        {
          "question": "Nên chọn Face ID hay vân tay?",
          "answer": "Face ID thuận tiện khi không muốn chạm tay; vân tay phổ biến và dễ làm quen. Nên chọn theo người dùng, ngân sách và điều kiện cửa."
        },
        {
          "question": "Có cần khảo sát trước khi lắp không?",
          "answer": "Cửa tiêu chuẩn có thể sàng lọc từ hình ảnh và kích thước. Cửa đặc thù nên khảo sát trước khi thi công."
        },
        {
          "question": "Có thể xem giá và model trước không?",
          "answer": "Có. Danh mục khóa hiển thị model, biến thể và mức giá đang được công bố để bạn tham khảo trước."
        }
      ],
      "finalTitle": "Cần chọn khóa phù hợp với cửa đang dùng?",
      "finalBody": "Gửi hình cửa và nhu cầu sử dụng để T Smart đối chiếu nhanh model phù hợp trước khi bạn quyết định."
    },
    "en": {
      "navLabel": "Smart locks in Da Nang",
      "eyebrow": "DA NANG SOLUTIONS",
      "title": "Smart locks in Da Nang – model selection and installation planning",
      "metaTitle": "Smart Locks in Da Nang | Face ID & Fingerprint | T Smart",
      "metaDescription": "Smart locks in Da Nang for wood, aluminium and glass doors. Compare Face ID, fingerprint and vein-recognition models with installation guidance.",
      "intro": "T Smart matches smart locks to actual door structure, thickness, stile width and daily use before installation in Da Nang.",
      "categoryCta": "Browse all smart locks",
      "contactCta": "Ask via Zalo",
      "highlightsTitle": "Match the lock to real installation conditions",
      "highlights": [
        {
          "title": "Door compatibility",
          "body": "Check wood, aluminium, glass and gate doors together with fitting dimensions."
        },
        {
          "title": "Access technology",
          "body": "Compare Face ID, fingerprint, PIN, card and vein recognition by user needs."
        },
        {
          "title": "Installation planning",
          "body": "Review lock-body dimensions, opening direction and finish before installation."
        }
      ],
      "selectionTitle": "A practical 3-step selection process",
      "selectionIntro": "Door construction and fitting dimensions matter more than appearance alone.",
      "selection": [
        {
          "title": "1. Identify the door",
          "body": "Record material, thickness, stile width and opening direction."
        },
        {
          "title": "2. Choose access methods",
          "body": "Prioritise technologies that suit family members and convenience needs."
        },
        {
          "title": "3. Compare models",
          "body": "Review specifications, variants, pricing and installation fit."
        }
      ],
      "productsTitle": "Smart lock models on T Smart",
      "productsIntro": "Open current catalogue models to review details and compare.",
      "processTitle": "Consultation process in Da Nang",
      "process": [
        {
          "title": "Share requirements",
          "body": "Send door photos, basic dimensions and preferred features."
        },
        {
          "title": "Technical matching",
          "body": "Shortlist models against the door structure."
        },
        {
          "title": "Site check when needed",
          "body": "Unusual doors may need an on-site check."
        },
        {
          "title": "Install & configure",
          "body": "Align the lock, test operation and configure access."
        }
      ],
      "faqTitle": "Smart lock FAQs in Da Nang",
      "faqs": [
        {
          "question": "Can aluminium doors use Face ID locks?",
          "answer": "Many can, but stile width, thickness and lock-body clearance must be checked."
        },
        {
          "question": "Face ID or fingerprint?",
          "answer": "Face ID is touch-free; fingerprint is familiar and widely available. The best choice depends on users and the door."
        },
        {
          "question": "Is a site survey required?",
          "answer": "Standard doors can often be screened from photos; unusual structures are better checked first."
        },
        {
          "question": "Can I review prices first?",
          "answer": "Yes. Current catalogue pages show available models, variants and published prices."
        }
      ],
      "finalTitle": "Need help matching a lock to your door?",
      "finalBody": "Send a door photo and preferred features so T Smart can narrow down suitable models."
    }
  },
  {
    "slug": "ket-sat-thong-minh-da-nang",
    "industry": "safe",
    "categorySlug": "ket-sat",
    "serviceType": "Tư vấn két sắt thông minh",
    "vi": {
      "navLabel": "Két sắt thông minh Đà Nẵng",
      "eyebrow": "GIẢI PHÁP TẠI ĐÀ NẴNG",
      "title": "Két sắt thông minh Đà Nẵng – tư vấn & bán lẻ chính hãng",
      "metaTitle": "Két sắt thông minh Đà Nẵng | Chính hãng | T Smart",
      "metaDescription": "Tư vấn, bán lẻ két sắt thông minh chính hãng tại Đà Nẵng. So sánh kích thước, trọng lượng, vân tay, mã số, thương hiệu và giá.",
      "intro": "T Smart tư vấn két sắt chính hãng theo tài sản cần lưu trữ, kích thước không gian, trọng lượng, lối vận chuyển và phương thức mở. Mục tiêu là chọn đúng model cho vị trí đặt thực tế tại Đà Nẵng.",
      "categoryCta": "Xem toàn bộ két sắt",
      "contactCta": "Tư vấn két sắt qua Zalo",
      "highlightsTitle": "Những yếu tố cần kiểm tra trước khi mua két",
      "highlights": [
        {
          "title": "Kích thước & trọng lượng",
          "body": "Đối chiếu kích thước ngoài, khoang lưu trữ, trọng lượng và vị trí đặt."
        },
        {
          "title": "Phương thức mở",
          "body": "So sánh vân tay, mã PIN, chìa cơ dự phòng và kết nối ứng dụng nếu có."
        },
        {
          "title": "Vận chuyển & bố trí",
          "body": "Kiểm tra thang máy, cầu thang, cửa ra vào, tải trọng sàn và khoảng mở cánh."
        }
      ],
      "selectionTitle": "Chọn két theo nhu cầu sử dụng",
      "selectionIntro": "Kích thước lớn không phải lúc nào cũng tốt hơn. Hãy bắt đầu từ tài sản và vị trí đặt.",
      "selection": [
        {
          "title": "Gia đình",
          "body": "Cân bằng sức chứa giấy tờ, tiền mặt, trang sức và không gian phòng."
        },
        {
          "title": "Văn phòng",
          "body": "Cân nhắc hồ sơ, tần suất sử dụng, phân quyền và khả năng di chuyển."
        },
        {
          "title": "Âm tủ / trưng bày",
          "body": "Kiểm tra kích thước hộc, kết cấu chịu lực, nguồn điện và hành trình cơ cấu."
        }
      ],
      "productsTitle": "Một số mẫu két sắt đang có trên T Smart",
      "productsIntro": "Mở từng sản phẩm để xem kích thước, trọng lượng, phương thức mở và giá.",
      "processTitle": "Quy trình chọn két tại Đà Nẵng",
      "process": [
        {
          "title": "Xác định tài sản",
          "body": "Ước lượng loại tài sản và sức chứa cần thiết."
        },
        {
          "title": "Đo vị trí đặt",
          "body": "Kiểm tra rộng, sâu, cao và khoảng mở cửa két."
        },
        {
          "title": "Kiểm tra lối vận chuyển",
          "body": "Xác minh thang máy, cầu thang và các điểm hẹp."
        },
        {
          "title": "Chốt model",
          "body": "Đối chiếu công nghệ mở khóa, trọng lượng, giá và điều kiện hậu mãi."
        }
      ],
      "faqTitle": "Câu hỏi thường gặp về két sắt thông minh tại Đà Nẵng",
      "faqs": [
        {
          "question": "Nên chọn két bao nhiêu kg cho gia đình?",
          "answer": "Không có một mức chung cho mọi nhà. Cần cân bằng sức chứa, vị trí đặt, tải trọng sàn và khả năng vận chuyển."
        },
        {
          "question": "Két vân tay có cần chìa cơ dự phòng không?",
          "answer": "Tùy model. Nhiều mẫu có chìa cơ hoặc cổng cấp nguồn dự phòng; cần xem đúng thông số."
        },
        {
          "question": "Két lớn có giao lên tầng được không?",
          "answer": "Cần kiểm tra kích thước thang máy, cầu thang, cửa ra vào và tải trọng trước."
        },
        {
          "question": "Có thể xem giá Philips và BOKEE không?",
          "answer": "Có. Sản phẩm đủ dữ liệu sẽ hiển thị giá và thông số trực tiếp trên website."
        }
      ],
      "finalTitle": "Chưa biết chọn két bao nhiêu kg và kích thước nào?",
      "finalBody": "Gửi kích thước vị trí đặt và nhu cầu lưu trữ để T Smart giúp thu hẹp danh sách model."
    },
    "en": {
      "navLabel": "Smart safes in Da Nang",
      "eyebrow": "DA NANG SOLUTIONS",
      "title": "Smart safes in Da Nang – size, access technology and placement planning",
      "metaTitle": "Smart Safes in Da Nang | Philips & BOKEE | T Smart",
      "metaDescription": "Smart safes in Da Nang from Philips, BOKEE and more. Compare size, weight, fingerprint, PIN access and placement requirements.",
      "intro": "Choose a safe around storage needs, available space, weight, delivery access and unlocking methods rather than size or price alone.",
      "categoryCta": "Browse all safes",
      "contactCta": "Ask via Zalo",
      "highlightsTitle": "What to check before buying a safe",
      "highlights": [
        {
          "title": "Size & weight",
          "body": "Compare external dimensions, usable storage and total weight."
        },
        {
          "title": "Access methods",
          "body": "Review fingerprint, PIN, emergency key and app options."
        },
        {
          "title": "Delivery & placement",
          "body": "Check lifts, stairs, doorways, floor loading and door clearance."
        }
      ],
      "selectionTitle": "Choose a safe around the use case",
      "selectionIntro": "Bigger is not always better. Start with what you store and where the safe will go.",
      "selection": [
        {
          "title": "Home",
          "body": "Balance document, cash and jewellery storage with room layout."
        },
        {
          "title": "Office",
          "body": "Consider document capacity, frequency of use and user access."
        },
        {
          "title": "Built-in / display",
          "body": "Check cabinet dimensions, support, power and mechanism travel."
        }
      ],
      "productsTitle": "Safe models on T Smart",
      "productsIntro": "Open each product to review dimensions, weight, access methods and pricing.",
      "processTitle": "Safe selection process in Da Nang",
      "process": [
        {
          "title": "Define storage needs",
          "body": "Estimate the type and volume of valuables."
        },
        {
          "title": "Measure the location",
          "body": "Check width, depth, height and door clearance."
        },
        {
          "title": "Verify delivery access",
          "body": "Confirm lifts, stairs and narrow access points."
        },
        {
          "title": "Confirm the model",
          "body": "Compare technology, weight, price and service conditions."
        }
      ],
      "faqTitle": "Smart safe FAQs in Da Nang",
      "faqs": [
        {
          "question": "What safe weight is suitable for a home?",
          "answer": "There is no universal weight; storage, placement, floor loading and delivery access all matter."
        },
        {
          "question": "Does a fingerprint safe need an emergency key?",
          "answer": "It depends on the model. Many provide a key or external emergency power."
        },
        {
          "question": "Can a heavy safe be delivered upstairs?",
          "answer": "Lift dimensions, stairs, doorways and load limits should be checked first."
        },
        {
          "question": "Can I compare Philips and BOKEE prices online?",
          "answer": "Yes. Products with verified commercial data show published prices and specifications."
        }
      ],
      "finalTitle": "Not sure what safe size or weight to choose?",
      "finalBody": "Send placement dimensions and storage requirements so T Smart can narrow down suitable models."
    }
  },
  {
    "slug": "giai-phap-chieu-sang-da-nang",
    "industry": "lighting",
    "categorySlug": "den-chieu-sang",
    "serviceType": "Tư vấn giải pháp chiếu sáng",
    "vi": {
      "navLabel": "Giải pháp chiếu sáng Đà Nẵng",
      "eyebrow": "GIẢI PHÁP TẠI ĐÀ NẴNG",
      "title": "Thiết kế & giải pháp chiếu sáng Đà Nẵng – nhà ở, showroom",
      "metaTitle": "Thiết kế & giải pháp chiếu sáng Đà Nẵng | T Smart",
      "metaDescription": "Tư vấn, thiết kế giải pháp chiếu sáng và bán lẻ đèn chính hãng tại Đà Nẵng cho nhà ở, showroom; tối ưu CCT, CRI, góc chiếu và công suất.",
      "intro": "T Smart tư vấn và thiết kế chiếu sáng tại Đà Nẵng cho nhà ở, showroom và không gian thương mại; đồng thời cung cấp đèn chính hãng theo công suất, CCT, CRI, góc chiếu và vị trí lắp.",
      "categoryCta": "Xem toàn bộ đèn chiếu sáng",
      "contactCta": "Tư vấn chiếu sáng qua Zalo",
      "highlightsTitle": "Tối ưu ánh sáng theo mục đích sử dụng",
      "highlights": [
        {
          "title": "Nhà ở",
          "body": "Phân lớp ánh sáng nền, điểm nhấn và trang trí cho phòng khách, bếp, phòng ngủ."
        },
        {
          "title": "Showroom",
          "body": "Ưu tiên CRI, góc chiếu và khả năng tạo điểm nhấn cho sản phẩm trưng bày."
        },
        {
          "title": "Không gian thương mại",
          "body": "Cân bằng độ sáng, độ chói, hiệu suất và khả năng bảo trì."
        }
      ],
      "selectionTitle": "Các thông số nên xem trước khi chọn đèn",
      "selectionIntro": "Công suất chỉ là một phần. Hai mẫu đèn cùng watt có thể cho trải nghiệm rất khác nhau.",
      "selection": [
        {
          "title": "Nhiệt màu",
          "body": "Chọn ấm, trung tính hoặc trắng theo vật liệu, công năng và cảm giác mong muốn."
        },
        {
          "title": "CRI & chất lượng màu",
          "body": "Showroom và vật liệu nội thất thường cần khả năng hoàn màu tốt."
        },
        {
          "title": "Góc chiếu & vị trí",
          "body": "Downlight, Spotlight, Wall Washer và đèn ray cần bố trí theo đối tượng cần chiếu."
        }
      ],
      "productsTitle": "Một số sản phẩm chiếu sáng trên T Smart",
      "productsIntro": "Mở sản phẩm để xem công suất, nhiệt màu, góc chiếu, biến thể và thông số.",
      "processTitle": "Quy trình tư vấn chiếu sáng tại Đà Nẵng",
      "process": [
        {
          "title": "Xác định công năng",
          "body": "Phân chia khu vực sinh hoạt, làm việc, trưng bày và điểm nhấn."
        },
        {
          "title": "Đối chiếu mặt bằng",
          "body": "Xem kích thước phòng, cao độ trần, nội thất và bề mặt cần chiếu."
        },
        {
          "title": "Chọn nhóm đèn",
          "body": "Phối Downlight, Spotlight, đèn ray, Linear hoặc đèn trang trí."
        },
        {
          "title": "Chốt thông số",
          "body": "Xác định công suất, nhiệt màu, CRI, góc chiếu và số lượng."
        }
      ],
      "faqTitle": "Câu hỏi thường gặp về giải pháp chiếu sáng tại Đà Nẵng",
      "faqs": [
        {
          "question": "Phòng khách nên dùng 3000K hay 4000K?",
          "answer": "3000K ấm và thư giãn; 4000K trung tính và rõ hơn. Có thể phối hai lớp nếu mạch điều khiển phù hợp."
        },
        {
          "question": "CRI cao có quan trọng không?",
          "answer": "Có, đặc biệt với showroom, vật liệu nội thất và nơi cần thể hiện màu sắc chính xác."
        },
        {
          "question": "Spotlight khác Downlight thế nào?",
          "answer": "Downlight thường tạo nền rộng hơn; Spotlight tập trung để nhấn vật thể hoặc khu vực cụ thể."
        },
        {
          "question": "Có cần bản vẽ bố trí đèn không?",
          "answer": "Với công trình nhiều khu vực hoặc yêu cầu thẩm mỹ cao, bố trí theo mặt bằng giúp kiểm soát vị trí và số lượng tốt hơn."
        }
      ],
      "finalTitle": "Bạn đang chọn đèn cho nhà ở hoặc showroom tại Đà Nẵng?",
      "finalBody": "Gửi mặt bằng, cao độ trần và phong cách mong muốn để T Smart hỗ trợ định hướng nhóm đèn và thông số."
    },
    "en": {
      "navLabel": "Lighting solutions in Da Nang",
      "eyebrow": "DA NANG SOLUTIONS",
      "title": "Lighting solutions in Da Nang – fixtures, wattage, colour temperature and beam angle",
      "metaTitle": "Lighting Solutions in Da Nang | Home & Showroom | T Smart",
      "metaDescription": "Lighting solutions in Da Nang for homes, showrooms and commercial spaces. Compare downlights, spotlights, track lights, CCT, CRI and beam angles.",
      "intro": "Good lighting balances brightness, beam control, colour temperature, CRI, fixture placement and atmosphere for each zone.",
      "categoryCta": "Browse all lighting",
      "contactCta": "Ask via Zalo",
      "highlightsTitle": "Plan lighting around the way each space is used",
      "highlights": [
        {
          "title": "Homes",
          "body": "Layer ambient, accent and decorative lighting across living spaces."
        },
        {
          "title": "Showrooms",
          "body": "Prioritise CRI, beam angle and accent control for displayed products."
        },
        {
          "title": "Commercial spaces",
          "body": "Balance illumination, glare, efficiency and maintenance."
        }
      ],
      "selectionTitle": "Specifications worth checking first",
      "selectionIntro": "Wattage is only one variable; fixtures at the same wattage can create very different results.",
      "selection": [
        {
          "title": "Colour temperature",
          "body": "Choose warm, neutral or cool light around materials and function."
        },
        {
          "title": "CRI & colour quality",
          "body": "Display and material-focused spaces often benefit from better colour rendering."
        },
        {
          "title": "Beam angle & placement",
          "body": "Place downlights, spotlights and track lights around the target surface."
        }
      ],
      "productsTitle": "Lighting products on T Smart",
      "productsIntro": "Open a product to review wattage, CCT, beam angle, variants and specifications.",
      "processTitle": "Lighting consultation process in Da Nang",
      "process": [
        {
          "title": "Define the use",
          "body": "Separate living, working, display and accent zones."
        },
        {
          "title": "Review the plan",
          "body": "Consider room size, ceiling height and surfaces to be lit."
        },
        {
          "title": "Choose fixture groups",
          "body": "Combine downlights, spotlights, track and linear lighting."
        },
        {
          "title": "Confirm specifications",
          "body": "Set wattage, CCT, CRI, beam angle and quantities."
        }
      ],
      "faqTitle": "Lighting FAQs in Da Nang",
      "faqs": [
        {
          "question": "3000K or 4000K for a living room?",
          "answer": "3000K feels warmer; 4000K is more neutral. Both can be layered when controls allow."
        },
        {
          "question": "Does high CRI matter?",
          "answer": "Yes, especially for showrooms, interiors and spaces where accurate colour appearance matters."
        },
        {
          "question": "Spotlight vs downlight?",
          "answer": "Downlights usually provide broader ambient coverage while spotlights focus on a target."
        },
        {
          "question": "Do I need a lighting layout?",
          "answer": "For multi-zone or design-led projects, a layout helps control position, spacing and quantity."
        }
      ],
      "finalTitle": "Planning lighting for a home or showroom in Da Nang?",
      "finalBody": "Share the floor plan, ceiling height and desired style so T Smart can suggest suitable fixture groups."
    }
  },
  {
    "slug": "cong-tu-dong-da-nang",
    "industry": "gate",
    "categorySlug": "cong-tu-dong",
    "serviceType": "Tư vấn và lắp đặt cổng tự động",
    "vi": {
      "navLabel": "Cổng tự động Đà Nẵng",
      "eyebrow": "GIẢI PHÁP TẠI ĐÀ NẴNG",
      "title": "Thi công cổng tự động Đà Nẵng – âm sàn, tay đòn & cổng trượt",
      "metaTitle": "Thi công cổng tự động Đà Nẵng | T Smart",
      "metaDescription": "Tư vấn, cung cấp và thi công lắp đặt cổng tự động tại Đà Nẵng. Motor âm sàn, tay đòn, cổng trượt chính hãng theo tải trọng và chiều dài cánh.",
      "intro": "T Smart chuyên tư vấn và thi công lắp đặt cổng tự động tại Đà Nẵng. Motor được chọn theo kiểu cổng, trọng lượng, chiều dài cánh, tần suất vận hành, nguồn điện và điều kiện công trình.",
      "categoryCta": "Xem toàn bộ cổng tự động",
      "contactCta": "Tư vấn cổng qua Zalo",
      "highlightsTitle": "Chọn đúng cơ cấu motor cho từng loại cổng",
      "highlights": [
        {
          "title": "Motor âm sàn",
          "body": "Ưu tiên thẩm mỹ, giấu cơ cấu dưới nền nhưng cần kiểm tra điều kiện thi công hố motor."
        },
        {
          "title": "Motor tay đòn",
          "body": "Dễ tiếp cận bảo trì và phù hợp nhiều cổng mở cánh khi đủ không gian lắp."
        },
        {
          "title": "Motor cổng trượt",
          "body": "Phù hợp cổng trượt ngang, cần kiểm tra tải, ray, hành trình và mặt bằng."
        }
      ],
      "selectionTitle": "Các thông số cần xác minh trước khi chọn motor",
      "selectionIntro": "Không nên chọn motor chỉ theo công suất. Trọng lượng, chiều dài cánh và kết cấu cơ khí phải được xem cùng nhau.",
      "selection": [
        {
          "title": "Tải trọng & kích thước",
          "body": "Ghi nhận trọng lượng ước tính, chiều dài và số cánh."
        },
        {
          "title": "Tần suất vận hành",
          "body": "Nhà ở và khu vực ra vào thường xuyên có yêu cầu chu kỳ khác nhau."
        },
        {
          "title": "An toàn & dự phòng",
          "body": "Cân nhắc cảm biến, photocell, mở tay và nguồn dự phòng."
        }
      ],
      "productsTitle": "Một số thiết bị cổng tự động trên T Smart",
      "productsIntro": "Xem từng model để đối chiếu tải trọng, điện áp, cơ cấu và phụ kiện.",
      "processTitle": "Quy trình tư vấn cổng tự động tại Đà Nẵng",
      "process": [
        {
          "title": "Khảo sát loại cổng",
          "body": "Xác định cổng mở cánh hay trượt, kích thước và hiện trạng."
        },
        {
          "title": "Tính tải & hành trình",
          "body": "Đối chiếu trọng lượng, chiều dài cánh, góc mở và không gian motor."
        },
        {
          "title": "Chọn motor & phụ kiện",
          "body": "Ghép motor với board, remote, cảm biến an toàn và dự phòng."
        },
        {
          "title": "Lắp đặt & cân chỉnh",
          "body": "Cân chỉnh hành trình, lực đóng mở, điểm dừng và an toàn."
        }
      ],
      "faqTitle": "Câu hỏi thường gặp về cổng tự động tại Đà Nẵng",
      "faqs": [
        {
          "question": "Nên dùng motor âm sàn hay tay đòn?",
          "answer": "Âm sàn ưu tiên thẩm mỹ; tay đòn dễ tiếp cận và thường thi công đơn giản hơn. Cần xem kết cấu thực tế."
        },
        {
          "question": "Mất điện có mở cổng được không?",
          "answer": "Nhiều hệ có mở tay và có thể bổ sung nguồn dự phòng; cần kiểm tra theo model."
        },
        {
          "question": "Có cần cảm biến an toàn không?",
          "answer": "Khu vực có người, xe hoặc trẻ nhỏ qua lại nên cân nhắc cảm biến an toàn."
        },
        {
          "question": "Có thể chọn motor chỉ theo trọng lượng cổng không?",
          "answer": "Không nên. Chiều dài cánh, bản lề, ma sát, tần suất và điều kiện thi công cũng ảnh hưởng."
        }
      ],
      "finalTitle": "Cần chọn motor phù hợp với cổng hiện tại?",
      "finalBody": "Gửi hình cổng, chiều dài cánh và kiểu mở để T Smart định hướng cơ cấu motor và phụ kiện."
    },
    "en": {
      "navLabel": "Automatic gates in Da Nang",
      "eyebrow": "DA NANG SOLUTIONS",
      "title": "Automatic gates in Da Nang – underground, swing-arm and sliding motors",
      "metaTitle": "Automatic Gates in Da Nang | Gate Motors | T Smart",
      "metaDescription": "Automatic gate solutions in Da Nang. Compare underground, swing-arm and sliding motors by gate weight, leaf length and site conditions.",
      "intro": "Gate motors should be selected around gate type, weight, leaf length, operating frequency and power conditions.",
      "categoryCta": "Browse all automatic gates",
      "contactCta": "Ask via Zalo",
      "highlightsTitle": "Match the motor mechanism to the gate",
      "highlights": [
        {
          "title": "Underground motors",
          "body": "Useful when a clean appearance matters and the site can accommodate the motor box."
        },
        {
          "title": "Swing-arm motors",
          "body": "Accessible for maintenance and suitable for many swing gates."
        },
        {
          "title": "Sliding motors",
          "body": "Designed for lateral sliding gates and require checks on rail, load and travel."
        }
      ],
      "selectionTitle": "Specifications to verify before choosing a motor",
      "selectionIntro": "Motor power alone is not enough; gate weight, leaf length and mechanical condition matter together.",
      "selection": [
        {
          "title": "Weight & dimensions",
          "body": "Estimate gate weight, leaf length and number of leaves."
        },
        {
          "title": "Operating frequency",
          "body": "Residential and higher-traffic entrances can require different duty cycles."
        },
        {
          "title": "Safety & backup",
          "body": "Consider photocells, safety sensors, manual release and backup power."
        }
      ],
      "productsTitle": "Automatic gate products on T Smart",
      "productsIntro": "Open each model to compare load ratings, voltage, mechanism and accessories.",
      "processTitle": "Automatic gate consultation process in Da Nang",
      "process": [
        {
          "title": "Assess the gate",
          "body": "Identify swing or sliding construction, dimensions and condition."
        },
        {
          "title": "Calculate load & travel",
          "body": "Review weight, leaf length, opening angle and motor space."
        },
        {
          "title": "Select motor & accessories",
          "body": "Match controls, remotes, safety sensors and backup options."
        },
        {
          "title": "Install & calibrate",
          "body": "Set travel, force, stop positions and verify safety."
        }
      ],
      "faqTitle": "Automatic gate FAQs in Da Nang",
      "faqs": [
        {
          "question": "Underground or swing-arm motors?",
          "answer": "Underground systems prioritise appearance; swing arms are more accessible. Site conditions should decide."
        },
        {
          "question": "Can the gate open during a power cut?",
          "answer": "Many systems provide manual release and may support backup power."
        },
        {
          "question": "Are safety sensors necessary?",
          "answer": "They are worth considering where people, vehicles or children regularly pass."
        },
        {
          "question": "Can I choose by gate weight alone?",
          "answer": "No. Leaf length, hinges, friction, usage frequency and installation conditions also matter."
        }
      ],
      "finalTitle": "Need help matching a motor to your gate?",
      "finalBody": "Send a gate photo, leaf length and opening type so T Smart can narrow down suitable motors."
    }
  }
];

export const localServiceBySlug = new Map(localServicePages.map((page) => [page.slug, page]));
export const localServicePaths = localServicePages.flatMap((page) => [`/${page.slug}`, `/en/${page.slug}`]);

export function localServiceCopy(page: LocalServicePageDefinition, locale: Locale) {
  return page[locale];
}
